import { FormControl, FormHelperText } from '@mui/material';
import { DefaultComponentProps, OverridableTypeMap } from '@mui/material/OverridableComponent';
import { Control, Controller, FieldValues, Path, PathValue, useFormContext } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

type IProps<ControlData extends FieldValues = FieldValues> = {
  id: Path<ControlData>;
  control: Control<ControlData>;
  defaultValue?: PathValue<ControlData, Path<ControlData>>;
  maxDateValue?: Date;
  minDateValue?: Date;
  readOnly?: boolean;
} & DefaultComponentProps<OverridableTypeMap>;

const FormDatePicker = <T extends FieldValues = FieldValues>(props: IProps<T>) => {
  const {
    maxDateValue,
    minDateValue,
    id,
    control,
    defaultValue,
    readOnly = false,
    ...rest
  } = props;

  const {
    formState: { errors },
  } = useFormContext<T>();
  const errorMessage = errors[id]?.message as string | undefined;
  const hasError = !!errorMessage;

  return (
    <FormControl {...rest} error={hasError}>
      <Controller
        render={({ field }) => (
          <DatePicker
            {...rest}
            {...field}
            maxDate={maxDateValue}
            minDate={minDateValue}
            readOnly={readOnly}
            slotProps={{
              textField: {
                error: hasError,
                helperText: errorMessage,
              },
            }}
          />
        )}
        name={id}
        control={control}
        defaultValue={defaultValue}
      />
    </FormControl>
  );
};

export default FormDatePicker;
